import "react-datepicker/dist/react-datepicker.css";

import { DateRangeResponse, TDateRangeProps } from "./DateRangePicker.type";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { es } from "date-fns/locale";

import DatePicker from "react-datepicker";
import moment from "moment";
import { useState } from "react";
import { useSearchParams } from "react-router-dom";

export default function DateRangePicker({ onChange }: TDateRangeProps) {
  const [dateRange, setDateRange] = useState<DateRangeResponse>([null, null]);
  const [startDate, endDate] = dateRange;
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [searchParams, setSearchParams] = useSearchParams();
  const fromParam = searchParams.get("from");
  const toParam = searchParams.get("to");

  const addCalendarIcon = () => {
    let my_elem = document.getElementById("DateRangePicker");
    let span = document.createElement("span");
    span.innerHTML = `<img src="/images/CalendarIcon.svg" alt="CalendarIcon"/>`;
    span.className = "DateRangePicker-CalendarIcon";
    my_elem?.parentNode?.insertBefore(span, my_elem);
  };

  /* const addDropdownIcon = () => {
    let my_elem = document.getElementById("DateRangePicker");
    let span = document.createElement("span");
    span.innerHTML = `<img src="/images/CalendarDownCarot.svg" alt="CalendarIcon"/>`;
    span.className = "DateRangePicker-DropdownIcon";
    my_elem?.parentNode?.insertBefore(span, my_elem.nextSibling);
  }; */

  const monthAbbr: any = {
    Jan: "ene",
    Feb: "feb",
    Mar: "mar",
    Apr: "abr",
    May: "may",
    Jun: "jun",
    Jul: "jul",
    Aug: "ago",
    Sep: "set",
    Oct: "oct",
    Nov: "nov",
    Dec: "dic",
  };

  const formatDate = (date: string) => {
    const month = date.substring(3, 6);
    return date.replace(month, monthAbbr[month]).replaceAll("-", " ");
  };

  const placeHolderText = (date: [string | null, string | null]) => {
    if (date.every((d) => d !== null)) {
      const dateFrom = moment(date[0], "DD MM YYYY").format("DD-MMM-YYYY");
      const dateTo = moment(date[1], "DD MM YYYY").format("DD-MMM-YYYY");

      const placheholderFrom = formatDate(dateFrom);
      const placheholderTo = formatDate(dateTo);

      return `${placheholderFrom} - ${placheholderTo}`;
    }

    const todaysDate = moment().format("DD-MMM-YYYY");
    const placeholder = formatDate(todaysDate);
    return `${placeholder} - ${placeholder}`;
  };

  addCalendarIcon();
  // addDropdownIcon();

  return (
    <>
      <LocalizationProvider adapterLocale={es} dateAdapter={AdapterDateFns}>
        <DatePicker
          id="DateRangePicker"
          className={"rounded-lg border-0 w-72 text-center"}
          placeholderText={placeHolderText([fromParam, toParam])}
          selectsRange={true}
          startDate={startDate}
          endDate={endDate}
          onChange={(update: DateRangeResponse) => {
            onChange(update);
            setDateRange(update);
          }}
          isClearable={true}
          dateFormat="dd/MM/yyyy"
        />
      </LocalizationProvider>
    </>
  );
}
